import {RootRef} from "../common";

export class ShadowRootRef extends RootRef {
    constructor(public container: HTMLElement, public shadowRoot: ShadowRoot) {
        super(container, shadowRoot);
    }
}
